import { useEffect, useMemo, useState } from "react";
import { AssetResolver, loadAssetPack, type AssetPackManifest } from "@craftoff/asset-pack-core";

const emergencyManifest: AssetPackManifest = {
  schemaVersion: 1,
  packId: "emergency",
  name: "Emergency",
  version: "1.0.0",
  author: "Craftoff",
  license: "Original",
  minimumGameVersion: "0.1.0",
  assets: {}
};

const emergencyAssetPaths: Record<string, string> = {
  "ui.button": "/fallback/ui/button.png",
  "ui.button_hover": "/fallback/ui/button_highlighted.png",
  "ui.dirt": "/fallback/ui/dirt.png",
  "ui.inventory_slot": "/fallback/ui/slot.png",
  "ui.menu_background": "/fallback/ui/menu_background.png",
  "ui.panorama": "/fallback/ui/panorama.png"
};

export function useAssets() {
  const [manifest, setManifest] = useState<AssetPackManifest | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    loadAssetPack("/fallback")
      .then(({ manifest: loaded }) => { if (active) setManifest(loaded); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);

  const resolver = useMemo(() => new AssetResolver(manifest ?? emergencyManifest, "/fallback"), [manifest]);
  const resolve = (assetId: string) => {
    try { return resolver.resolve(assetId); } catch { return emergencyAssetPaths[assetId] ?? ""; }
  };

  return { resolve, packName: manifest?.name ?? "Fallback", ready: Boolean(manifest), failed };
}
